import React from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { MainContainer } from "./MailTokenName.styled";

const MailTokenName = (props) => {
  const { data, editMailToken, fullData } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to mail token view page
    if (fullData && fullData.id) {
      navigate(`/administration/emails/view/${fullData.id}`);
    }
  };

  return (
    <MainContainer>
      <span 
        className="mailtoken-list__link" 
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        {data}
      </span>
    </MainContainer>
  );
};

MailTokenName.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  editMailToken: PropTypes.func,
  fullData: PropTypes.object,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MailTokenName);
